import React from 'react'
import "./SubStyle.css"

const Acc_Capital = () => {
  return (
    <section className="OurServices">
     <h1 className="OurServices-title">Capital Allowances</h1>
      <p className="OurServices-pera">Maximise the tax relief available on qualifying business assets and property investments. We identify eligible expenditure and help you claim the allowances you're entitled to, improving cash flow and reducing tax liabilities.</p>
         <div className="btn-container">
        <button className="OurServices-btn">
       <a>Let's get started</a>
      </button>
     </div>
    </section>
  )
}

export default Acc_Capital
